import {
  Button,
  Typography,
} from '@mui/material';
import {styled} from '@mui/system';
import {
  Box,
  Link,
} from '@zoom/react-ui';

import zoomPalette from '../../zoomPalette';

export const EventContainer = styled(Box, {shouldForwardProp: (p) => !['isInClient', 'isInWebPortal'].includes(p)})(
  ({isInClient, isInWebPortal, theme}) => ({
    padding: isInWebPortal ? '32px 48px' : (isInClient) ? 0 : '24px 48px',
    minWidth: '450px',
    // height: '100%',
  })
);

export const TypographyH2 = styled(Typography)(({theme}) => ({
  lineHeight: '2rem',
  fontSize: '1.5rem',
  fontWeight: '700',
}));

export const StyledLink = styled(Link)(({theme}) => ({
  'color': zoomPalette.gray[90],
  'width': '100%',
  'padding': '6px 8px',
  'textDecoration': 'none',
  '&:hover': {
    color: zoomPalette.white,
  },
}));

export const StyledButton = styled(Button)(({theme}) => ({
  'color': theme.palette.text?.strongerNeutral || '#2A2B2D',
  'lineHeight': '18px',
  'background': zoomPalette.white,
  'width': '100%',
  // 'flexGrow': 1,
  'height': '32px',
  'fontSize': '14px',
  'justifyContent': 'left',
  'fontWeight': 'normal',
  'borderRadius': '6px',
  'border': `none !important`,
  'padding': '8px',
  '&:hover': {
    background: zoomPalette.lightBlue,
  },
  '&.isActive': {
    color: zoomPalette.white,
    background: zoomPalette.blue[60],
  },
}));

export const FeedbackBtn = styled('a')(({theme}) => ({
  fontWeight: '500',
  fontSize: '14px',
  color: theme.palette.primary.swatch['70'],
  textDecoration: 'none',
  marginRight: '16px',
}));

export const TitleTag = styled('span')(({color = 'blue'}) => ({
  border: `1px solid ${zoomPalette[color][30]}`,
  background: zoomPalette[color][10],
  padding: '4px 6px',
  borderRadius: '999px',
  fontSize: '10px',
  color: zoomPalette[color][60],
  fontWeight: 700,
  height: '22px',
  lineHeight: 'initial',
  marginLeft: '10px',
  textTransform: 'uppercase',
  textWrap: 'nowrap',
  flexShrink: 0,
}));

export const RowLink = styled(Link)(({theme}) => ({
  'color': theme.palette.common.black,
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));
